import React from 'react';
import { Container, Typography, Box, Paper, Divider, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

const CGUPage = () => {
    const navigate = useNavigate();

    return (
        <Box sx={{ bgcolor: '#f5f7fa', minHeight: '100vh', py: 8 }}>
            <Container maxWidth="md">
                <Button
                    startIcon={<ArrowBackIcon />}
                    onClick={() => navigate(-1)}
                    sx={{ mb: 4, textTransform: 'none' }}
                >
                    Retour
                </Button>

                <Paper elevation={0} sx={{ p: { xs: 4, md: 6 }, borderRadius: 4, border: '1px solid #e2e8f0' }}>
                    <Typography variant="h3" component="h1" gutterBottom sx={{ fontWeight: 800, color: '#2d3748' }}>
                        Conditions Générales d'Utilisation
                    </Typography>
                    <Typography variant="body2" color="text.secondary" gutterBottom>
                        Dernière mise à jour : 22/12/2025 15:00
                    </Typography>

                    <Divider sx={{ my: 4 }} />

                    <Box sx={{ mt: 4 }}>
                        <Typography variant="h5" gutterBottom sx={{ fontWeight: 700, mt: 4 }}>
                            1. Objet des CGU
                        </Typography>
                        <Typography variant="body1" paragraph>
                            Les présentes Conditions Générales d'Utilisation (ci-après « CGU ») ont pour objet de définir les conditions et modalités d'utilisation de la plateforme LMS Edu-JALM par l'utilisateur.
                        </Typography>

                        <Typography variant="h5" gutterBottom sx={{ fontWeight: 700, mt: 4 }}>
                            2. Accès à la Plateforme
                        </Typography>
                        <Typography variant="body1" paragraph>
                            L'accès à la plateforme est réservé aux clients ayant souscrit un contrat de prestation de services et aux apprenants inscrits par ces derniers. L'utilisateur reconnaît disposer de la compétence et des moyens techniques nécessaires pour accéder à la plateforme.
                        </Typography>

                        <Typography variant="h5" gutterBottom sx={{ fontWeight: 700, mt: 4 }}>
                            3. Engagements de l'Utilisateur
                        </Typography>
                        <Typography variant="body1" paragraph>
                            L'utilisateur s'engage à utiliser la plateforme conformément à sa destination et à ne pas porter atteinte à son bon fonctionnement. Il est responsable du maintien de la confidentialité de ses identifiants de connexion.
                        </Typography>

                        <Typography variant="h5" gutterBottom sx={{ fontWeight: 700, mt: 4 }}>
                            4. Propriété Intellectuelle
                        </Typography>
                        <Typography variant="body1" paragraph>
                            L'ensemble des contenus présents sur la plateforme (textes, vidéos, images, outils) est la propriété exclusive du Prestataire ou de ses partenaires. Toute reproduction ou diffusion sans autorisation préalable est strictement interdite.
                        </Typography>

                        <Typography variant="h5" gutterBottom sx={{ fontWeight: 700, mt: 4 }}>
                            5. Responsabilité
                        </Typography>
                        <Typography variant="body1" paragraph>
                            Le Prestataire met tout en œuvre pour assurer la disponibilité du service. Toutefois, il ne peut être tenu responsable des interruptions de service dues à des causes extérieures ou à des opérations de maintenance.
                        </Typography>

                        <Typography variant="h5" gutterBottom sx={{ fontWeight: 700, mt: 4 }}>
                            6. Signalement et Support
                        </Typography>
                        <Typography variant="body1" paragraph>
                            Tout dysfonctionnement peut être signalé via l'outil de support intégré à la plateforme ou par email à l'adresse report@edu-jalm.fr.
                        </Typography>

                        <Typography variant="h5" gutterBottom sx={{ fontWeight: 700, mt: 4 }}>
                            7. Modification des CGU
                        </Typography>
                        <Typography variant="body1" paragraph>
                            Le Prestataire se réserve le droit de modifier les présentes CGU à tout moment. Les modifications seront applicables dès leur mise en ligne sur la plateforme.
                        </Typography>
                    </Box>
                </Paper>
            </Container>
        </Box>
    );
};

export default CGUPage;
